const benefits = [
  { icon: 'ri-ruler-2-line', label: 'Made to Measure', desc: 'Engineered to your exact footprint' },
  { icon: 'ri-palette-line', label: 'Custom Colors', desc: 'Match any brand or theme palette' },
  { icon: 'ri-shapes-line', label: 'Unique Shapes', desc: 'Hexagonal, rectangular, asymmetric' },
  { icon: 'ri-settings-3-line', label: 'Bespoke Configurations', desc: 'Multi-pole, tiered, open-sided' },
  { icon: 'ri-tools-line', label: 'Expert Installation', desc: 'Trained crew from start to finish' },
];

export default function BenefitsStrip() {
  return (
    <section className="py-16 bg-white border-t border-gray-100">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-gray-900 text-center mb-10">
          Why Choose a Custom Tent?
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-5">
          {benefits.map((b, i) => (
            <div
              key={i}
              className="bg-gray-50 rounded-xl p-5 text-center hover:scale-105 transition-transform duration-300 cursor-default"
            >
              <div className="w-12 h-12 mx-auto mb-3 bg-teal-50 rounded-xl flex items-center justify-center">
                <i className={`${b.icon} text-2xl text-teal-400`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-1">{b.label}</h3>
              <p className="text-xs text-gray-500 leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
